export default "__VITE_ASSET__2e9d5df0__"